import { render, staticRenderFns } from "./EloadViewRewards2.vue?vue&type=template&id=eb850de0"
import script from "./EloadViewRewards2.vue?vue&type=script&lang=js"
export * from "./EloadViewRewards2.vue?vue&type=script&lang=js"
import style0 from "./EloadViewRewards2.vue?vue&type=style&index=0&id=eb850de0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports